import { planIsFree } from './subscriptionPlanPricing';

/** Active vendor subscription from admin vendor list payload. */
export function getVendorActiveSubscription(vendor) {
  const subs = vendor?.vendor_subscriptions || vendor?.vendorSubscriptions || [];
  return subs.find((s) => s.status === 'active') || null;
}

/** True when vendor has no paid plan (free slug or zero-price plan). */
export function isVendorOnFreePlan(vendor) {
  const active = getVendorActiveSubscription(vendor);
  if (!active?.subscription) {
    return true;
  }
  return planIsFree(active.subscription);
}

/** Vendors eligible for spotlight / success story pickers (paid plans only). */
export function isVendorEligibleForSpotlight(vendor) {
  return Boolean(vendor?.vendor_profile || vendor?.vendorProfile) && !isVendorOnFreePlan(vendor);
}
